import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Table, Spin, Select } from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: "Branch ",
    dataIndex: "branch",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "Accounting Closure Date",
    dataIndex: "accountingclosuredate",
  },

  {
    title: "Comments",
    dataIndex: "comments",
  },

  {
    // title: "Close Accounting created by",
    title: "Close Account Created By",
    dataIndex: "closeAccountingCreatedBy",
  },
];

const GLA0800 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { endOfCirclesItems, monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [officeData, setOfficeData] = useState([]);
  const [endOfCircleList, setEndOfCircleList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setEndOfCircleList(originalList);
      return;
    }
    // console.log(originalList);
    const filterBySearch = originalList.filter((item) =>
      item?.branch?.toLowerCase().includes(searchKey)
    );
    // console.log(filterBySearch);
    setEndOfCircleList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [BOM.HasPermission("READ_GLCLOSURE") && cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };
  //END METHODS DECLARED

  useEffect(() => {
    getOfficeListAction();
    getEndOfCirclesAction();
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    BOM.HasPermission("CREATE_GLCLOSURE") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getOfficeListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetOfficeList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        // console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(temp);
      }
    });
  };

  const getEndOfCirclesAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetEndOfCircles, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            branch: element?.officeName,
            accountingclosuredate: element?.closingDate
              ? `${element?.closingDate[2]} ${monthList[element?.closingDate[1] - 1]} ${
                  element?.closingDate[0]
                }`
              : "-",
            comments: element?.comments ? element?.comments : "-",
            closeAccountingCreatedBy: element?.createdByUsername,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setEndOfCircleList(tempArray.filter((item) => item.disabled === false));
        setEndOfCircleList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, definedApi.GetEndOfCircles, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              branch: element?.officeName,
              accountingclosuredate: element?.closingDate
                ? `${element?.closingDate[2]} ${monthList[element?.closingDate[1] - 1]} ${
                    element?.closingDate[0]
                  }`
                : "-",
              comments: element?.comments ? element?.comments : "-",
              closeAccountingCreatedBy: element?.createdByUsername,
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0800", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla0800", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-gla0800", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView} onAdd={handleOnCreate}>
      <TopContent pageTitle={appLabel.accountClosure} pageItems={endOfCirclesItems} />

      <Card
        title={`${appLabel.accountClosure} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Branch..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={endOfCircleList}
              columns={columns}
              fileName={"Account Closure List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={endOfCircleList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(GLA0800);
